// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"4fdb6356","134":"4740d1a5","280":"d46c0a30","439":"6dd4c227","651":"14e82661","957":"e78ace7d","967":"31d6cfe0","970":"715aeedb","994":"78e3286c"}[chunkId] + ".chunk.css";
};